"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvVariable = exports.assertValidClerkState = exports.assertEnvVar = exports.warnForSsr = void 0;
const errors_1 = require("./errors");
function warnForSsr(val) {
    if (!val || !val.__internal_clerk_state) {
        console.warn(errors_1.noClerkStateError);
    }
}
exports.warnForSsr = warnForSsr;
function assertEnvVar(name, errorMessage) {
    if (!name || typeof name !== 'string') {
        throw new Error(errorMessage);
    }
}
exports.assertEnvVar = assertEnvVar;
function assertValidClerkState(val) {
    if (!val) {
        throw new Error(errors_1.noClerkStateError);
    }
    if (!!val && !val.__internal_clerk_state) {
        throw new Error(errors_1.invalidClerkStatePropError);
    }
}
exports.assertValidClerkState = assertValidClerkState;
/**
 *
 * Utility function to get env variables across Node and Edge runtimes.
 *
 * @param name
 * @returns
 */
const getEnvVariable = (name) => {
    // Node envs
    if (typeof process !== 'undefined') {
        return (process.env && process.env[name]) || '';
    }
    // Cloudflare workers
    try {
        // @ts-expect-error
        return globalThis[name];
    }
    catch (_) {
        // This will raise an error in Cloudflare Pages
    }
    return '';
};
exports.getEnvVariable = getEnvVariable;
